module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/016-nepal-f2e915825a218dc17b24655b37f911d7.svg";